import React, { useContext } from 'react'
import {useParams} from 'react-router-dom'
import {Card, CardBody, CardHeader, Spinner} from '@chakra-ui/react'
import {CountingTabs} from './CountingTabs/CountingTabs'
import {useApi} from '../../hooks/useApi/useApi'
import {CountingHeader} from './CountingHeader/CountingHeader'
import { CountingContext, CountingProvider } from 'stores/CountingContext'


export const Counting = () => {
    const {countingId} = useParams()
    // const {counting, fetchCounting, updateCounting, setCounting} = useApi()
    // const [ style, setStyle ] = useState({ position: 'fixed', bottom: '0'})

    // useEffect(() => {
    //     fetchCounting(countingId)
    //     // changeStyle()
    //     // window.addEventListener('scroll', changeStyle)

    //     // return () => {
    //     //     window.removeEventListener('scroll', changeStyle)
    //     // }
    // }, [])

    // const changeStyle = () => {
    //     console.log(window.scrollY)
    //     if (window.scrollY > 0) {
    //         setStyle({position: 'fixed', top: '0'})
    //     } else {
    //         setStyle({})
    //     }
    // }

    // if (!counting) {
    //     return <Spinner/>  // или любой другой индикатор загрузки
    // }

    return (
        <CountingProvider countingId={countingId}>
            <Card>
                <CardHeader style={{ position: 'fixed', bottom: '0', zIndex: '5'}}>
                    <CountingHeader />
                </CardHeader>
                <CardBody>
                    <CountingTabs />
                </CardBody>
            </Card>
        </CountingProvider>
    )
}
